module.exports = __webpack_public_path__ + "static/img/2-8.70412f90.png";